var map = {
	"./Asset 64.svg": "06f2",
	"./Asset 65.svg": "4a71",
	"./PE_GG60_1920x1080.webp": "e86b",
	"./cerrar.svg": "ba45",
	"./diana_off.webp": "38c3",
	"./diana_on.webp": "e9e1",
	"./flecha_abajo.webp": "c9a8",
	"./flecha_derecha.webp": "8b14",
	"./flecha_izquierda.webp": "48fd",
	"./flechas_blancas.webp": "8716",
	"./flechas_negras_derecha.svg": "c943",
	"./flechas_negras_izquierda.svg": "a7de",
	"./flechas_rojas.webp": "dd91",
	"./grupo-restaurantero-gigante-github.webp": "08a6",
	"./imagen_construccion.webp": "3e77",
	"./imagen_portada_video.webp": "60e6",
	"./imagen_portada_video1.webp": "5019",
	"./mapa_beer.svg": "3e60",
	"./mapa_farolito.svg": "9c90",
	"./mapa_panda.svg": "3890",
	"./mapa_shake.svg": "b256",
	"./mapa_toks.svg": "0620",
	"./marcador.svg": "fce8",
	"./marcador1.svg": "ae29",
	"./mas.svg": "80d4",
	"./numeralia_cedis_1.png": "a8da",
	"./numeralia_cedis_1.svg": "b017",
	"./numeralia_cedis_2.png": "985a",
	"./numeralia_cedis_2.svg": "608a",
	"./numeralia_cedis_3.png": "8f06",
	"./numeralia_cedis_3.svg": "1a1a",
	"./numeralia_cedis_4.png": "1df7",
	"./numeralia_cedis_4.svg": "5e24",
	"./numeralia_cedis_5.png": "ff33",
	"./numeralia_cedis_5.svg": "14df",
	"./numeralia_cedis_51.webp": "d74e",
	"./numeralia_cedis_5otro.webp": "1239",
	"./numeralia_home1.svg": "4f6e",
	"./numeralia_home2.svg": "ad9d",
	"./numeralia_home3.svg": "bef4",
	"./numeralia_home4.svg": "9527",
	"./numeralia_home5.svg": "489f",
	"./patrones.webp": "46ae",
	"./play.svg": "c29b",
	"./sobre.svg": "defa",
	"./telefono.svg": "23d7",
	"./toggler.svg": "6605"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed8b";